import { render, staticRenderFns } from "./msg_list.vue?vue&type=template&id=b7ac3d14&scoped=true"
import script from "./msg_list.vue?vue&type=script&lang=js"
export * from "./msg_list.vue?vue&type=script&lang=js"
import style0 from "./msg_list.vue?vue&type=style&index=0&id=b7ac3d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ac3d14",
  null
  
)

export default component.exports